import { generateChart } from './DefaultChart'
import { reactiveData } from './mixins/data-update'
import { SuperDuperDoughnutChart } from './extra'

const Doughnut = generateChart('Doughnut', 'SuperDuperDoughnutChart')

const defaultChartData = (canvasCtx) => ({
    labels: [],
    datasets: [
        {
            backgroundColor: '#30A7FE',
            // maxBarThickness: 15,
            // barPercentage: .1,
            // categoryPercentage: .1,
            data: [],
            cutout: '90%',
            borderWidth: 0
            // hoverBorderWidth: 8
            // borderRadius: 38
        }
    ]
})

export default {
    extends: Doughnut,
    mixins: [reactiveData],
    props: {
        dataToRender: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    data() {
        return {
            chartData: null,
            options: {
                layout: {
                    padding: {
                        top: -100,
                        bottom: -100,
                        left: -100,
                        right: -100
                    }
                },
                responsive: true,
                elemements: {
                    arc: {
                        borderWidth: 0,
                        offset: 0,
                        spacing: 10
                    }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    fullSize: false,
                    maxHeight: 0,
                    maxWidth: 0
                },
                tooltip: {
                    enabled: false
                },
                title: {
                    display: false,
                    padding: 0
                }
            }
        }
    },
    watch: {
        dataToRender: {
            handler: function (newData, oldData) {
                // if (!this.chartData) this.initChart();
                if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
                    if (newData.length > 0) {
                        setTimeout(this.fillData.bind(this, [...newData]), 0)
                    } else {
                        setTimeout(this.fillData.bind(this, newData), 0)
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options, [SuperDuperDoughnutChart])
    },
    methods: {
        fillData(data = []) {
            const labels = data.map(({ name }) => name)
            const dataToFill = data.map(({ value, isActive }) => value)
            const backgroundColors = data.map(({ color }) => color)
            this.chartData = defaultChartData()
            this.chartData.datasets[0].labels = labels
            this.chartData.datasets[0].backgroundColor = backgroundColors
            this.chartData.datasets[0].data = dataToFill
        }
    }
}
